import { flatMap, map, pick, reject } from 'lodash';
import { DEFAULT_SUBSET_ATTRIBUTE_KEYS } from './const/studentManagementConstants';

const buildStudentGroupRows = (v2Grouping, subsetKeys = DEFAULT_SUBSET_ATTRIBUTE_KEYS) => {
  const { schoolGroups = [], cocurriculumGroups = [], allGroups = [] } = v2Grouping || {};
  const seenIds = new Set();
  const attributesByGroupId = new Map(
    map(allGroups, (group) => [`${group.id}`, pick(group, subsetKeys)])
  );

  const toRow = (source, baseRow) => {
    const id = `${source.id}`;
    seenIds.add(id);
    return {
      id,
      group: source.name,
      ...baseRow,
      ...attributesByGroupId.get(id)
    };
  };

  const rowsForSchool = (school) =>
    flatMap(school.years, (year) => [
      toRow(year, { school: `${school.id}` }),
      ...map(year.classes, (studentClass) => toRow(studentClass, { parent: `${year.id}` })),
      ...map(year.subjects, (subject) =>
        toRow(subject, { parent: `${year.id}`, subjectGroup: true })
      )
    ]);

  const schoolRows = flatMap(schoolGroups, rowsForSchool);
  const cocurriculumRows = map(cocurriculumGroups, (group) => toRow(group, { customGroup: true }));
  const unmappedRows = map(
    reject(allGroups, (group) => seenIds.has(`${group.id}`)),
    (group) => toRow(group, {})
  );

  return [...schoolRows, ...cocurriculumRows, ...unmappedRows];
};

export default buildStudentGroupRows;
export { DEFAULT_SUBSET_ATTRIBUTE_KEYS };
